// based on rc-tree 1.14.8
'use strict'

module.exports = require('./src/')



// WEBPACK FOOTER //
// ./components/vc-tree/index.js